import { utilFunctionService } from "@/utils/utils.service"
export default function auth ({ next }) {
  const user = utilFunctionService.getLocalStorageService("user");
  if (!user) {
    return next({ name: 'login' })
  }
  const roles = utilFunctionService.getUserRoles();
  if (!roles || !roles.includes('admin')) {
    utilFunctionService.removeLocalStorageService("user");
    return next({ name: 'login' })
  }
  return next()
}
